import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  transition: opacity 0.3s;\n  opacity: ', ';\n'], ['\n  transition: opacity 0.3s;\n  opacity: ', ';\n']);

import { css } from 'styled-components';

var isLoadingStyle = css(_templateObject, function (_ref) {
  var isLoading = _ref.isLoading;
  return isLoading ? 0 : 1;
});

var getLoadingStyle = function getLoadingStyle(_ref2) {
  var isLoading = _ref2.isLoading;
  return {
    transition: 'opacity 0.3s',
    opacity: isLoading ? 0 : 1
  };
};

export { isLoadingStyle, getLoadingStyle };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/button/dist/esm/styled/utils.js
// module id = 250
// module chunks = 0